import styled, { css } from '@xstyled/styled-components'

export const RecorderViewWrapper = styled.div`
  box-sizing: border-box;
  max-width: 100vw;
  overflow-x: hidden;
  overflow-y: hidden;
  height: auto;
  margin-top: 3rem;

  display: grid;
  grid-template-columns: 1fr;
  place-items: center;
`

export const RecorderAudioInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 400px;
`

export const MicButtonWrapper = styled.div`
  position: relative;
  margin-bottom: 4;
`

export const RecorderIntroWrapper = styled.div`
  ${({ theme }) => css`
    margin: 0 auto;
    padding: ${theme.space[2]}px 0;
    line-height: 1.5;
    text-align: center;
    position:relative;

    ${theme.mediaQueries.aboveMobile} {
      max-width: 600px;
      padding: ${theme.space[2]}px;
    }
  `}
`

export const ReviewButtonsWrapper = styled.div`
  display: grid;
  padding-top: 10px;
  grid-template-columns: 1;
  grid-row-gap: 15px;
`
